import { render, staticRenderFns } from "./ManufacturerEdit.vue?vue&type=template&id=97306dc0&scoped=true"
import script from "./ManufacturerEdit.vue?vue&type=script&lang=js"
export * from "./ManufacturerEdit.vue?vue&type=script&lang=js"
import style0 from "./ManufacturerEdit.vue?vue&type=style&index=0&id=97306dc0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97306dc0",
  null
  
)

export default component.exports